function createIcon(type, googleMaps) {
  const icon = {
    size: new googleMaps.Size(34, 45),
    scaledSize: new googleMaps.Size(34, 45),
    origin: new googleMaps.Point(0, 0),
    anchor: new googleMaps.Point(17, 45),
    url: '',
  };

  switch (type) {
    case 'Airstop':
      icon.url = `/_resources/themes/${window.THEME_NAME}/images/marker-airstop.png`;
      break;

    case 'Truck stop':
      icon.url = `/_resources/themes/${window.THEME_NAME}/images/marker-truckstop.png`;
      break;

    default:
      icon.url = `/_resources/themes/${window.THEME_NAME}/images/marker-servicestation.png`;
      break;
  }

  return icon;
}

export default createIcon;
